import { render } from "./TextTruncationPage.vue?vue&type=template&id=3085dd3b&ts=true"
import script from "./TextTruncationPage.vue?vue&type=script&lang=ts"
export * from "./TextTruncationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__